import type { Cell, PieceType } from '../engine/constants';
import { previewShape, toShape, type Game } from '../engine/game';
import type { Layout } from './layout';

export function renderBoard(layout: Layout, game: Game): void {
  for (let row = 0; row < layout.boardCells.length; row++) {
    for (let col = 0; col < layout.boardCells[row].length; col++) {
      const el = layout.boardCells[row][col];
      const cellValue: Cell = game.board[row][col];
      el.dataset.piece = cellValue;
      el.classList.remove('ghost', 'active');
    }
  }

  const ghost = game.ghost;
  if (ghost) {
    for (const [col, row] of toShape(ghost)) {
      const el = layout.boardCells[row]?.[col];
      if (el) {
        el.dataset.piece = ghost.piece;
        el.classList.add('ghost');
      }
    }
  }

  if (game.current) {
    for (const [col, row] of toShape(game.current)) {
      const el = layout.boardCells[row]?.[col];
      if (el) {
        el.dataset.piece = game.current.piece;
        el.classList.remove('ghost');
        el.classList.add('active');
      }
    }
  }
}

function renderPreviewGrid(container: HTMLElement, piece: PieceType | null): void {
  container.innerHTML = '';
  if (!piece) return;
  const shape = previewShape(piece);
  const xs = shape.map(([x]) => x);
  const ys = shape.map(([, y]) => y);
  const minX = Math.min(...xs);
  const maxX = Math.max(...xs);
  const minY = Math.min(...ys);
  const maxY = Math.max(...ys);
  const width = maxX - minX + 1;
  const height = maxY - minY + 1;
  container.style.gridTemplateColumns = `repeat(${width}, var(--preview-cell))`;
  container.style.gridTemplateRows = `repeat(${height}, var(--preview-cell))`;

  const filled = new Set(shape.map(([x, y]) => `${x - minX},${maxY - y}`));
  for (let row = 0; row < height; row++) {
    for (let col = 0; col < width; col++) {
      const cell = document.createElement('div');
      if (filled.has(`${col},${row}`)) {
        cell.className = 'cell preview-cell';
        cell.dataset.piece = piece;
      } else {
        cell.className = 'cell preview-cell preview-cell-empty';
      }
      container.append(cell);
    }
  }
}

export function renderHold(layout: Layout, game: Game): void {
  renderPreviewGrid(layout.holdGrid, game.holdPiece);
  layout.holdGrid.parentElement?.classList.toggle('used', game.holdUsed);
}

export function renderNext(layout: Layout, game: Game): void {
  const upcoming = game.peekNext(layout.nextSlots.length);
  upcoming.forEach((piece, i) => renderPreviewGrid(layout.nextSlots[i], piece));
}

export function formatClock(ms: number): string {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}
